import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import UsersList from './UsersList/UsersList';
import UserShow from './UserShow/UserShow';
import UserEdit from './UserEdit/UserEdit';
import UserCreate from './UserCreate/UserCreate';
import UserDelete from './UserDelete/UserDelete';

const Users = ({match}) => {
    return (
        <div className="Users">
            <ContainerWrapper container="users">
                <Route exact path={ match.path } component={UsersList} />
                <Route exact path={ `${ match.url }/new` } component={UserCreate} />
                <Route exact path={ `${ match.url }/show/:userId` } component={UserShow} />
                <Route exact path={ `${ match.url }/edit/:userId` } component={UserEdit} />
                <Route exact path={ `${ match.url }/delete/:userId` } component={UserDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Users;
